var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.taskMultiShows
    ? _c("div", { staticClass: "popup" }, [
        _vm.taskMultiShows
          ? _c(
              "div",
              { staticClass: "onedrive4Buiness-errors" },
              [
                _c(
                  "el-carousel",
                  {
                    ref: "carousel",
                    attrs: {
                      interval: 0,
                      arrow: "never",
                      "indicator-position": "none"
                    }
                  },
                  [
                    _c("div", { staticClass: "content-box" }, [
                      _c("div", { staticClass: "text-box" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.common.oneDrive4BusinessContent")
                            )
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "new-box" }, [
                  _c("div", { staticClass: "photo-gallery" }, [
                    _c("img", {
                      staticClass: "gallery-image",
                      attrs: { src: _vm.steps[_vm.activeIndex].image }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tips-box" }, [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(_vm.steps[_vm.activeIndex].tip)
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "title-long-text" }, [
                    _c("div", { staticClass: "semicircle-box" }, [
                      _c("div", { staticClass: "title-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t(_vm.steps[_vm.activeIndex].title))
                          )
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "note-box" }, [
                  _c("div", { staticClass: "nested-line" }, [
                    _c("span", { staticClass: "note-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("language.common.onedriveBusinessContentNote")
                        )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "carousel-delete-button",
                    on: {
                      click: function($event) {
                        return _vm.hideAndReset()
                      }
                    }
                  },
                  [_c("div", { staticClass: "carousel-delete-icon" })]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "footer" }, [
                  _c(
                    "div",
                    { staticClass: "indicators" },
                    _vm._l(_vm.steps, function(item, index) {
                      return _c("span", {
                        key: index,
                        class: { active: _vm.activeIndex === index },
                        on: {
                          click: function($event) {
                            return _vm.setActive(index)
                          }
                        }
                      })
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.activeIndex > 0
                    ? _c(
                        "button",
                        { staticClass: "up-button", on: { click: _vm.upStep } },
                        [_vm._v(_vm._s(_vm.$t("language.common.upStep")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "next-button",
                      on: {
                        click: function($event) {
                          _vm.isLastStep ? _vm.hideAndReset() : _vm.nextStep()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.isLastStep
                              ? _vm.$t("language.common.complete")
                              : _vm.$t("language.common.nextStep")
                          ) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ],
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76c25634", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76c25634","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/list_onedrivebuiness_folder_error.vue
// module id = null
// module chunks = 